import { render, staticRenderFns } from "./Locations.vue?vue&type=template&id=18475ecc"
import script from "./Locations.vue?vue&type=script&lang=js"
export * from "./Locations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports